module.exports = __webpack_public_path__ + "header_one.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/header_one.jpg
// module id = 1729
// module chunks = 11